export default {
  loadingapp: true,
  longloader: {
    show: false,
    message: ""
  },
  errormessage: "",
  infomessage: "",
  warningmessage: undefined,
  user: undefined,
  baseDataLoaded: false,
  azureMapKey: null,
  languages: [],
  admin: {
    users: undefined,
    contacts: undefined,
    translations: undefined,
  },
  devices: [],
  currentDevice: undefined,
  currentDeviceHistoricalData: {},
  currentDeviceAlarmData: {},
  currentDevicePir: false,
  kpis: [],
  iotSignalR: {
    // flag signalR is Connected after open
    isConnected: false,   
    // signalR HUB connection 
    hubConnection: null,
    // the sensor list with all received signaR values     
    deviceData: {},
  },
  userSignalR: {
    isConnected: false,
    hubConnection: null,
    devices: {}
  }
};
